import React, { useState, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import './SmartDrill.css';
import './FourLines.css';
import KidMotherImage from '../../assets/pageimages/KidWithMother.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';

function SmartDrillFourLines() {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedTime(prevTime => prevTime + 1);
    }, 1000); // Update elapsed time every second

    return () => clearInterval(interval);
  }, []);

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const lettersUpper = [
    'A', 'B', 'C', 'D', 'E', 'F',
    'G', 'H', 'I', 'J', 'K', 'L',
    'M', 'N', 'O', 'P', 'Q', 'R',
    'S', 'T', 'U', 'V', 'W', 'X',
    'Y', 'Z'
  ];

  const lettersLower = [
    'a', 'b', 'c', 'd', 'e', 'f',
    'g', 'h', 'i', 'j', 'k', 'l',
    'm', 'n', 'o', 'p', 'q', 'r',
    's', 't', 'u', 'v', 'w', 'x',
    'y', 'z'
  ];

  const numerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  const cursiveUpper = [
    'A', 'B', 'C', 'D', 'E', 'F',
    'G', 'H', 'I', 'J', 'K', 'L',
    'M', 'N', 'O', 'P', 'Q', 'R',
    'S', 'T', 'U', 'V', 'W', 'X',
    'Y', 'Z'
  ];

  const cursiveLower = [
    'a', 'b', 'c', 'd', 'e', 'f',
    'g', 'h', 'i', 'j', 'k', 'l',
    'm', 'n', 'o', 'p', 'q', 'r',
    's', 't', 'u', 'v', 'w', 'x',
    'y', 'z'
  ];

  const [selectedSet, setSelectedSet] = useState('uppercase');
  const [lettersPerLine, setLettersPerLine] = useState(1);


  const handleSetChange = (event) => {
    setSelectedSet(event.target.value);
  };

  const handleLettersPerLineChange = (event) => {
    setLettersPerLine(parseInt(event.target.value));
  };

  const getDisplayedSet = () => {
    switch (selectedSet) {
      case 'uppercase':
        return lettersUpper;
      case 'lowercase':
        return lettersLower;
      case 'numerals':
        return numerals;
      case 'cursiveUppercase':
        return cursiveUpper;
      case 'cursiveLowercase':
        return cursiveLower;
      default:
        return [];
    }
  };

  const renderLetters = () => {
    const sets = [];
    const displayedSet = getDisplayedSet();
    const numSets = Math.ceil(displayedSet.length / lettersPerLine);
    for (let i = 0; i < numSets; i++) {
      const start = i * lettersPerLine;
      const end = Math.min((i + 1) * lettersPerLine, displayedSet.length);
      sets.push(displayedSet.slice(start, end));
    }
    return sets.map((set, index) => (
      <div key={index} className="letter-set">
        <div className="lines-container mb-4">
          <div className="line red"></div>
          <div className="line white"></div>
          <div className="line white"></div>
          <div className="line red"></div>
        </div>
        <div className="letter-container">
          {set.map((letter, letterIndex) => (
            <span key={letterIndex} className={`overlay-letter ${selectedSet.includes('cursive') ? 'cursive' : ''}`}>{letter}</span>
          ))}
        </div>
      </div>
    ));
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mb-2 mx-2 border-b border-b-gray-300 text-white'>SMARTDrill - Four Lines</h2>
      </div>
      <div className="flex justify-center mt-1 mb-1 ml-4 mr-4 relative">
      <img className="align-middle" src={KidMotherImage} alt="KidMotherImage" />
      <div className="timer-and-speaker absolute top-0 right-0 flex items-center">
        <span className="timer">{formatTime(elapsedTime)}</span>
        <FontAwesomeIcon icon={faVolumeUp} className="ml-2" />
      </div>
    </div>
      <div className="mx-auto max-w-[760px]">
        <div className="radio-buttons mx-auto max-w-[760px] flex justify-center ml-4 mr-4">
          <label>
            <input
              type="radio"
              value="uppercase"
              checked={selectedSet === 'uppercase'}
              onChange={handleSetChange}
            />
            Upper Case 
          </label>
          <label>
            <input
              type="radio"
              value="lowercase"
              checked={selectedSet === 'lowercase'}
              onChange={handleSetChange}
            />
            Lower Case 
          </label>
          <label>
            <input
              type="radio"
              value="numerals"
              checked={selectedSet === 'numerals'}
              onChange={handleSetChange}
            />
            Numerals
          </label>
          <label>
            <input
              type="radio"
              value="cursiveUppercase"
              checked={selectedSet === 'cursiveUppercase'}
              onChange={handleSetChange}
            />
            Cursive Upper 
          </label>
          <label>
            <input
              type="radio"
              value="cursiveLowercase"
              checked={selectedSet === 'cursiveLowercase'}
              onChange={handleSetChange}
            />
            Cursive Lower 
          </label>
        </div>
        <div className="radio-buttons mx-auto max-w-[760px] ml-4 mr-4">
          {/* Radio buttons for selecting the number of letters per line */}
          <label>
            <input
              type="radio"
              value="1"
              checked={lettersPerLine === 1}
              onChange={handleLettersPerLineChange}
            />
            1 Letter Per Line
          </label>
          <label>
            <input
              type="radio"
              value="6"
              checked={lettersPerLine === 6}
              onChange={handleLettersPerLineChange}
            />
            6 Letters Per Line
          </label>
        </div>
        <div className="mx-auto max-w-[760px] ml-4 mr-4">
          {renderLetters()}
        </div>
      </div>
    </MainLayout>
  );
}

export default SmartDrillFourLines;
